<template>
    <form onsubmit="return false;">
        <div>
            <filter-view-switch :entity-filter-key="entityFilterKey"
                                :filter-fields="availableFilterConfigs"
                                :disable="isPopModal">
                <div class="row">
                    <div class="form-group" :class="filterCss" v-for="col in filterFields"
                         v-bind:key="getCol(col).key">
                        <label id="filterLabel" class="control-label">{{ $t(getCol(col).label) }}:</label>
                        <em-form-helper
                            is-editing
                            :metadata="getCol(col)"
                            :value="$_emCustomVuexMixin_filterStore[getCol(col).key]"
                            @selectModalEntity="showModal(getCol(col))"
                            @selectMultipleModalEntity="showCheckEnableModal(getCol(col))"
                            @bind="changeFilterAttribute(getCol(col), $event)"
                            @input="changeFilterAttribute(getCol(col), $event)"
                            @keypress.enter.native="doQuery"
                        />
                    </div>
                </div>
            </filter-view-switch>
            <div class="row mt-1">
                <div class=" col-lg-12 align-self-end">
                    <!-- 自定义列 -->
                    <template v-if="!customizationDisabled" class="float-lg-left">
                        <button
                            class="btn btn-outline-secondary mr-1"
                            type="button"
                            v-on:click="openCustomization()"
                        >
                            <i class="fa fa-fw fa-lg fa-sliders"></i>
                        </button>
                    </template>
                    <div class="float-lg-right">
                        <button
                            class="btn btn-outline-secondary mr-1"
                            type="button"
                            v-on:click="doClear()"
                        >
                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                        </button>
                        <button class="btn btn-primary" type="button" v-on:click="doQuery" :disabled="onSearching">
                            <i class="fa fa-fw fa-lg fa-search"></i>
                            <span class="text">{{ $t("btn.basic.search") }}</span>
                            <b-spinner v-show="onSearching" small></b-spinner>
                        </button>
                        <Customization ref="Customization" :vuexFieldConfigs="availableFilterConfigs"
                                       :localstorageFieldConfigsKey="localstorageFieldConfigsKey"
                                       @customizationSave="filterFieldsReload"></Customization>
                    </div>
                </div>
            </div>
        </div>

        <filter-suggestion v-if="queryTag" :tag="queryTag" :field-list="filterFields"
                           no-auto-show
                           @setFilter="setFilter"></filter-suggestion>
    </form>
</template>


<script>
import EmFormHelper from "@/components/em/EmFormHelper";
import {mapActions} from "vuex";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import Customization from "@/components/em/EmTable/Customization";
import defaultQueryControlMixin from "@/components/em/EmFilter/default-query-control-mixin";
import FilterSuggestion from "@/components/em/EmFilter/FilterSuggestion.vue";
import FilterViewSwitch from "@/components/em/EmFilter/FilterViewSwitch.vue";
// import { debug } from 'util';

export default {
    name: "em-filter",
    mixins: [emCustomVuexMixin, defaultQueryControlMixin],
    data() {
        return {
            onSearching: false,
            filterFieldsVersion: 1
        }
    },
    components: {FilterViewSwitch, FilterSuggestion, EmFormHelper, Customization},
    props: {
        entity: {
            type: String,
            request: true
        },
        filterCss: {
            type: String,
            default: 'col-md-2'
        },
        queryApi: {
            type: String,
            default: 'findByFilter'
        },
        queryPrepareMutation: {
            type: String,
            default: ''
        },
        withPagination: {
            type: Boolean,
            default: true
        },
        //禁用自定义列按钮
        customizationDisabled: {
            type: Boolean,
            default: false
        },
        //需要从筛选区中排除的筛选项key。
        //用于同一个 model 被多个页面共用、但某些页面不该有某些筛选项的场景
        //（例如供应商门户与采购员页面共用 sithMesStoolPrPrice 的 filterConfigs，
        //  但"发询价人员工号/供应商编号(多选)/物料编号(多选)"不应出现在供应商门户）。
        //排除发生在 availableFilterConfigs，所以筛选区和"自定义列"弹窗都取不到这些项。
        excludeFieldKeys: {
            type: Array,
            default: () => []
        },
        ignoreMaxTableItemLimit: {
            type: Boolean,
            default: false
        },
        isPopModal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localstorageFieldConfigsKey() {
            return `em-filter-custom-fields-${this.entityFilterKey}`
        },
        entityFilterKey() {
            return `${this.entity}-${this.$_emCustomVuexMixin_filter}`;
        },
        //扣掉本页面不该出现的筛选项后的 filterConfigs
        availableFilterConfigs() {
            let configs = this.$_emCustomVuexMixin_filterConfigs
            if (!configs || !this.excludeFieldKeys || this.excludeFieldKeys.length === 0) {
                return configs
            }
            return configs.filter(f => this.excludeFieldKeys.indexOf(f.key) === -1)
        },
        //filter fields 数据
        filterFields() {
            //通过让计算属性绑定data，来控制计算属性的刷新。
            if (this.filterFieldsVersion) {
            }
            let filterFields = this.availableFilterConfigs
            //如果曾经自定义过，就用自定义字段顺序循环取重新取一下字段名
            if (localStorage[this.localstorageFieldConfigsKey]) {
                let localStorageKeyArray = JSON.parse(localStorage[this.localstorageFieldConfigsKey])
                let customFilterFields = []
                localStorageKeyArray.forEach(lsf => {
                    filterFields.find(f => f.key === lsf.key) && customFilterFields.push(filterFields.find(f => f.key === lsf.key))
                })
                filterFields = customFilterFields
                console.log(filterFields)
            }
            // 去掉详情列
            // if (!this.showDetail && !localStorage[this.localstorageFieldConfigsKey]) {
            //   filterFields = filterFields.filter(f => !f.isDetail);
            // }
            return filterFields;
        }
    },
    methods: {
        openCustomization() {
            this.$refs.Customization.open();
        },
        filterFieldsReload() {
            this.filterFieldsVersion++
        },
        changeFilterAttribute(col, $event) {
            let key = col.key
            let newValue = $event
            // let filterFirstUpperCase = this.filterState.replace(this.filterState[0], this.filterState[0].toUpperCase());
            // this.$store.commit(`${this.entity}/set${filterFirstUpperCase}Attribute`, {key, newValue});
            this.$_emCustomVuexMixin_setFilterAttribute(key, newValue)
            //如果是entitySelect，还可以在值发生变化后，触发预先定义的action，可以是一组action
            //在entityForm组件和filter组件中都会调用下面的代码，通过最后的type参数是：entity/filter来区分是谁调用的  - 2020-6-19
            if (col.form.type === "entitySelect") {
                console.log("进入绑定：entitySelect")
                console.log(key)
                let id = $event ? $event : 0;
                if (col.form.onChangeDispatchAction) {
                    for (var i in col.form.onChangeDispatchAction) {
                        var onChangeDispatchActionParams = col.form.onChangeDispatchActionParams && col.form.onChangeDispatchActionParams[i]
                            ? col.form.onChangeDispatchActionParams[i] : {}
                        this.$store.dispatch(col.form.onChangeDispatchAction[i], {
                            id, //原设计，我只能予以保留了，怕影响到原来的什么功能，虽然没搜索到这个的调用
                            key,
                            newValue,
                            mainEntity: this.entity,
                            type: 'entity',
                            onChangeDispatchActionParams
                        });
                    }
                }
            }
        },
        showModal(col) {
            this.$emit("showEntityModalSelect", {
                popCol: col,
                filterState: this.$_emCustomVuexMixin_filter,
                entity: this.entity
            });
        },
        showCheckEnableModal(col) {
            this.$emit("showEntityMultipleModalSelect", {
                popCol: col,
                filterState: this.$_emCustomVuexMixin_filter,
                entity: this.entity
            });
        },
        getCol(col) {
            //如果type存在并且等于“variable”，并且存在dependentStateKey和forms，就返回true
            if (col.type && col.type === "variable" && col.dependentStateKey && col.forms) {
                //判断是不是moduleRoot，是就不拼装filter了，在entityForm中要拼装entity
                let dependentState = col.dependentStateByModuleRoot
                    ? this.$store.state[this.entity][col.dependentStateKey]
                    : this.$_emCustomVuexMixin_filterStore[col.dependentStateKey]
                if (dependentState && col.forms[dependentState]) {
                    return col.forms[dependentState]
                }
            }
            return col;
        },
        doQuery() {
            if (this.noDefaultQuery && !this.mounted) {
                if (this.gatherConfig() == null) {
                    this.skipped = true;
                    return;
                } else {
                    this.$nextTick(() => this.$message.info("正在执行条件查询..."));
                }
            }
            this.onSearching = true;
            this.emBaseQueryByFilter({
                entity: this.entity,
                filterState: this.$_emCustomVuexMixin_filter,
                queryApi: this.queryApi,
                loadState: this.$_emCustomVuexMixin_vo,
                ignoreMaxTableItemLimit: this.ignoreMaxTableItemLimit,
                queryPrepareMutation: this.queryPrepareMutation,
                withPagination: this.withPagination
            }).then((response) => {
                this.$_emCustomVuexMixin_needToRefresh = false
                this.$emit("emFilterQueried", response)
            }).finally(() => this.onSearching = false)
        },
        doClear() {
            this.emBaseClearFilter({
                entity: this.entity,
                filterState: this.$_emCustomVuexMixin_filter,
                loadState: this.$_emCustomVuexMixin_vo
            })
            this.$emit("doClear");
        },
        gatherConfig() {
            let temp = Object.assign({}, this.$_emCustomVuexMixin_filterStore);
            for (let key in temp) {
                let item = temp[key];
                if (temp.hasOwnProperty(key) && (item === ""
                    || item == null
                    || item instanceof Array && item.length === 0
                    || typeof item === 'object' && Object.keys(item).length === 0)) {
                    delete temp[key];
                }
            }
            if (Object.keys(temp).length === 0) {
                return null;
            }
            return temp;
        },
        ...mapActions("emBase", ["emBaseQueryByFilter", "emBaseClearFilter"])
    }
};
</script>

<style scoped>
/*label{width:100% !important;}*/
#filterLabel {
    width: 100%
}

/* ===== EM 应用外壳现代化 (After·B)：em-filter 查询条 ===== */
/* 注：查询条外层白卡由页面已有的 .card 提供（见 _em_modern.scss），此处不再重复包卡，避免双框 */

/* 标签：小字次级色 */
.control-label {
    font-size: 11px;
    font-weight: 600;
    color: #5b6b7a;
    letter-spacing: .02em;
}

/* 输入控件：圆角 + 聚焦高亮环（控件由子组件渲染，需穿透） */
::v-deep .form-control,
::v-deep .custom-select,
::v-deep .vs__dropdown-toggle {
    border-radius: 8px;
    border-color: #dfe7ef;
}

::v-deep .form-control:focus,
::v-deep .custom-select:focus {
    border-color: #1E5274;
    box-shadow: 0 0 0 3px rgba(30, 82, 116, .1);
}
</style>
